import React, { useCallback } from 'react';
import styled from 'styled-components';
import { EMOJI_REACTION } from '@guuru/news-common';
import type { Sentiment } from '@guuru/news-common';

interface NewsEmojiPickerProps {
  // eslint-disable-next-line no-unused-vars
  onEmojiSelect: (_: Sentiment) => void;
}

const Picker = styled.div`
  padding: 0.2rem 0.5rem;
  font-size: 1.9rem;
  border-radius: 1.7rem;
  box-shadow: rgb(0 0 0 / 10%) 0 0 0 1px, rgb(0 0 0 / 10%) 0 2px 2px 0;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      margin: 0 0.16rem;

      button {
        all: unset;
        cursor: pointer;
        transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5);

        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
`;

const NewsEmojiPicker = function ({ onEmojiSelect }: NewsEmojiPickerProps) {
  const handleReactEvent = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const sentiment = EMOJI_REACTION[event.currentTarget.value];
      onEmojiSelect(sentiment);
    },
    [onEmojiSelect],
  );

  return (
    <Picker>
      <ul>
        {Object.entries(EMOJI_REACTION).map(([emoji, sentiment]) => (
          <li key={sentiment}>
            <button type="button" value={emoji} onClick={handleReactEvent}>
              {emoji}
            </button>
          </li>
        ))}
      </ul>
    </Picker>
  );
};

export default NewsEmojiPicker;
